// src/App.js
import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import Homepage from "./pages/Homepage";
import Servicepage from "./pages/Servicepage";
import Teampage from "./pages/Teampage";
import Contactpage from "./pages/Contactpage";


/* ===== Scroll helpers ===== */
const ScrollToHashElement = () => {
  const location = useLocation();

  React.useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 200);
      }
    }
  }, [location]);

  return null;
};

const ScrollToTop = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const App = () => {

  return (
    <div >
      <ScrollToTop />
      <ScrollToHashElement />

      <Routes>
        {/* Main pages */}
        <Route path="/" element={<Homepage />} />
        <Route path="/services" element={<Servicepage />} />
        <Route path="/about-us" element={<Teampage />} />   
         <Route path="/contact" element={<Contactpage />} />   
 



      </Routes>
    </div>
  );
};

export default App;
